<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer002">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer004">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB2.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Copyright-Heading">Copyright © Fiona Thollar 2024</p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">The right of </span><span class="CharOverride-2" xml:lang="en-US">Fiona Thollar </span><span class="CharOverride-1" xml:lang="en-US">to be identified as author of this work has been asserted by the author in accordance with section 77 and 78 of the Copyright, Designs and Patents Act 1988.</span></p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</span></p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</span></p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">A CIP catalogue record for this title is available from the British Library.</span></p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">ISBN 9781035825684 (Paperback)</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">ISBN 9781035825691 (Hardback)</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">ISBN 9781035825707 (ePub-e-book)</span></p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">www.austinmacauley.com</span></p>
<p class="Basic-Paragraph ParaOverride-1" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">First Published 2024</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">Austin Macauley Publishers Ltd®</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">1 Canada Square</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">Canary Wharf </span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">London</span></p>
<p class="Basic-Paragraph ParaOverride-2" lang="en-GB" xml:lang="en-GB"><span class="CharOverride-1" xml:lang="en-US">E14 5AA</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="Basic-Paragraph" lang="en-GB" xml:lang="en-GB"><img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/9781035825684_EPUB5.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer009">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer011">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer013">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB6.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB7.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer018">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer020">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer021">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer023">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer027">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer029">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer032">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer033">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer037">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer041">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer043">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer045">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer047">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer049">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer053">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer054">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB27.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB28.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035825684_EPUB29.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer060">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled8.vue?76bb35b1